import React from "react";
import { IEventDocument } from "@eagerdog/interfaces";

import Icon from "src/components/Icon/Icon";

import styles from "./DocumentsTab.module.scss";

interface IProps {
  document: IEventDocument;
  isAdmin: boolean;
  onEdit(doc: IEventDocument): void;
  onDelete(doc: IEventDocument): void;
}

const formatFileSize = (bytes: number): string => {
  if (!bytes) return "";
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const DocumentTile: React.FC<IProps> = (props) => {
  const doc = props.document;
  const isPdf = doc.mime_type === "application/pdf";

  return (
    <div className={styles.DocumentTile}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <div className={isPdf ? styles.pdfIcon : styles.imageIcon}></div>
          <div className={styles.textWrap}>
            <div className={styles.title}>{doc.name}</div>
            {doc.description && <div className={styles.description}>{doc.description}</div>}
          </div>
        </div>
        <div className={styles.right}>
          {props.isAdmin && (
            <div className={styles.actions}>
              <div className={styles.iconBtn} onClick={() => props.onEdit(doc)}><Icon className={styles.icon} type="edit" /></div>
              <div className={styles.iconBtn} onClick={() => props.onDelete(doc)}><Icon className={styles.icon} type="delete" /></div>
            </div>
          )}
          {doc.file_size ? <div className={styles.fileSize}>{formatFileSize(doc.file_size)}</div> : null}
          <a className={styles.downloadBtn} href={doc.file_url} target="_blank" rel="noreferrer" download={doc.file_name}>Download</a>
        </div>
      </div>
    </div>
  );
};

export default DocumentTile;
